import { toast } from "react-toastify";
import { FiCheckCircle, FiXCircle } from "react-icons/fi";

// Common configuration to avoid repetition
const toastOptions = {
  position: "top-right",
  autoClose: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
};

// Success Toast
export const showSuccessToast = (message) => {
  toast(
    <div className="flex items-center gap-3">
      <FiCheckCircle className="text-green-500 w-6 h-6 flex-shrink-0" />
      <span className="text-gray-800 dark:text-gray-100 font-semibold text-sm leading-tight">
        {message || "Success!"}
      </span>
    </div>,
    {
      ...toastOptions,
      // '!' forces these styles to override react-toastify defaults
      className:
        "!bg-white dark:!bg-gray-900 !border-l-4 !border-green-500 !shadow-xl !rounded-lg !p-4",
      bodyClassName: "p-0 flex items-center", // Removes extra default padding inside the toast
    },
  );
};

// Error Toast
export const showErrorToast = (message) => {
  toast(
    <div className="flex items-center gap-3">
      <FiXCircle className="text-red-500 w-6 h-6 flex-shrink-0" />
      <span className="text-gray-800 dark:text-gray-100 font-semibold text-sm leading-tight">
        {message || "Something went wrong"}
      </span>
    </div>,
    {
      ...toastOptions,
      autoClose: 4000,
      className:
        "!bg-white dark:!bg-gray-900 !border-l-4 !border-red-500 !shadow-xl !rounded-lg !p-4",
      bodyClassName: "p-0 flex items-center",
    },
  );
};
